(function () {
    'use strict';
    var controllerId = 'cndPartecipAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'common', '_', 'datacontext', 'apl', 'tRuoloCode', 'tMisuraCode', 'isSuper', cndPartecipAdd]);

    function cndPartecipAdd($scope, $uibModalInstance, common, _, datacontext, apl, tRuoloCode, tMisuraCode, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.record = {};
        $scope.record.TRuoloCode = tRuoloCode;
        $scope.record.TMisuraCode = tMisuraCode;
        $scope.apl = apl;
        $scope.isSuper = isSuper;

        $scope.listType = jQuery.extend([], datacontext.arrFORM_TAttivita());
        
        console.info('$scope.record', $scope.record);

        $scope.cndProgetti = [];
        $scope.getProgetti = getProgetti;

        if (tRuoloCode) {
            $scope.tRuoloCode = tRuoloCode;
        }

        if (tMisuraCode) {
            $scope.tMisuraCode = tMisuraCode;
        }
        

        $scope.ok = function (isValid) {
            if (isValid) {
                
                //var result = addItem($scope.record);
                var result = addOrUpdateItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.partecipazione_add(item).then(function (data) {
                return data;
            });
        }

        function addOrUpdateItem(item) {
            return datacontext.partecipazione_addOrUpdate(item).then(function (data) {
                return data;
            });
        }

        function getProgetti() {
            $scope.cndProgetti = [];
            if ($scope.record.TRuoloCode == 'AZD_FORM-LAV1' && $scope.record.FORM_Type == 'A') {
                return datacontext.cndProgetto_getAll(0, 0, '', '', '', $scope.record.TRuoloCode, '', 4, moment().format('DD/MM/YYYY'), '').then(function (data) {
                    var newData = [];
                    console.info('getProgetti', data);
                    if (data) {
                        data.forEach(function (item) {
                            if (item && item.Etichetta != 'G.O.L. - Partecipazioni Formazione') {
                                newData.push(item);
                            }
                        });
                    }
                    console.info('newData', newData);
                    return $scope.cndProgetti = newData;
                });
            }
        }
    }
})();